// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__B2ftH","gallery_container":"Gallery_gallery_container__BVTam"};